"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var flowRight_1 = tslib_1.__importDefault(require("lodash/flowRight"));
var chartDefinition_1 = require("../_commons/chartDefinition");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
/**
 * Hoc that transforms incoming props to BaseChart props according to chart definition
 * @internal
 */
function withChartDefinition(chartDefinition) {
    var getChartProps = chartDefinition_1.getCoreChartProps(chartDefinition);
    return function (Chart) {
        var WithChartDefinition = function (props) { return react_1.default.createElement(Chart, tslib_1.__assign({}, getChartProps(props))); };
        return sdk_ui_1.wrapDisplayName("withChartDefinition", Chart)(WithChartDefinition);
    };
}
/**
 * Common hoc for shared logic between all charts, injects contexts and transforms incoming props to BaseChart props according to chart definition
 * @internal
 */
exports.withChart = function (chartDefinition) {
    return function (Chart) {
        return flowRight_1.default(sdk_ui_1.wrapDisplayName("withChart"), sdk_ui_theme_provider_1.withTheme, sdk_ui_1.withContexts, withChartDefinition(chartDefinition))(Chart);
    };
};
//# sourceMappingURL=withChart.js.map